import { createActions } from 'redux-actions';

export default createActions(
  {
    CREATE: (payload) => payload,
    UPDATE: (payload) => payload,
    ADD_NOTE: (payload) => payload,
  },
  {
    prefix: 'Profile/BIOGRAPHICAL/NOTABLEAFFILIATIONS',
  }
);
